"use strict";

exports.__esModule = true;
exports.default = void 0;
var language = null;
var _lang = "zh-cn";
/**
 *
 */

var _default = {
  /**
   *
   * @param key
   * @returns {string}
   */
  get: function get(key) {
    if (language === null) return null;
    return language[_lang][key] || key;
  },

  /**
   *
   * @param val
   */
  set: function set(val) {
    language = language || {};
    language[_lang] = val;
  },

  /**
   *
   * @param val
   */
  lang: function lang(val) {
    _lang = val;
  }
};
exports.default = _default;
module.exports = exports.default;